import script from "./titleTile.vue?vue&type=script&setup=true&lang=js"
export * from "./titleTile.vue?vue&type=script&setup=true&lang=js"

import "./titleTile.vue?vue&type=style&index=0&id=a25fb586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a25fb586"]])

export default __exports__